import React, { useContext } from 'react';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Button } from 'primereact/button';
import { growlErrors } from '../utils/NotificationUtil';
import { NotificationContext } from './GrowlNotifications';
import { defineMessages, useIntl } from 'react-intl';
import { Loading } from './Loading';

const CREATE_CUSTOMER_PORTAL = gql`
  mutation createCustomerPortalMutation($input: CreateCustomerPortalInput!) {
    createCustomerPortal(input: $input) {
      url
    }
  }
`;

const i18nMessages = defineMessages({
  updateCreditCard: {
    id: 'account.subscription.update-credit-card',
    defaultMessage: 'Update Credit Card',
  },
});

const UpdateCreditCardButton = ({ managingAccountId, clientAccountId }) => {
  const growl = useContext(NotificationContext);
  const { formatMessage } = useIntl();

  const currentUrl = window.location.href;
  const queryParams = window.location.search;

  const [createCustomerPortalMutation, { loading }] = useMutation(CREATE_CUSTOMER_PORTAL);

  const createCustomerPortal = async () => {
    const noQueryParams = queryParams.length === 0;

    const redirectUrl = noQueryParams
      ? `${currentUrl}?creditCardChange=success`
      : `${currentUrl}&creditCardChange=success`;

    try {
      const {
        data: {
          createCustomerPortal: { url },
        },
      } = await createCustomerPortalMutation({
        variables: {
          input: {
            managingAccountId,
            clientAccountId,
            redirectUrl,
          },
        },
      });

      window.open(url, '_blank', 'noreferrer');
    } catch (mutationError) {
      growlErrors(growl, mutationError);
    }
  };

  if (loading) {
    return <Loading size="small" />;
  }

  return (
    <Button
      type="button"
      label={formatMessage(i18nMessages.updateCreditCard)}
      className="p-button-primary"
      onClick={createCustomerPortal}
    />
  );
};

export default UpdateCreditCardButton;
